import StoryblokService from "./service/storyblok-service";

export default StoryblokService;
